import moment from 'moment';
import {
  getPaymentFailedStatusLabel,
  getPaymentFailedOutcomeLabel,
  getPaymentFailedTrigger,
} from '../../../constants/paymentFailedOrders';

const formatDate = (value) =>
  value ? moment(new Date(value)).format('YYYY-MM-DD HH:mm') : '';

// Order/sales report columns first, then the recovery columns the ops team asked for
const CSV_COLUMNS = [
  { header: 'Reference No', value: (row) => row?.reference_no },
  { header: 'Order Date', value: (row) => formatDate(row?.order_created_at) },
  { header: 'Customer Name', value: (row) => row?.full_name },
  { header: 'Mobile', value: (row) => row?.phone },
  { header: 'Email', value: (row) => row?.email },
  { header: 'Country', value: (row) => (row?.country || '').toUpperCase() },
  { header: 'Order Value', value: (row) => row?.grand_total },
  { header: 'Currency', value: (row) => row?.currency },
  { header: 'Payment Mode', value: (row) => row?.payment_mode },
  { header: 'Gateway', value: (row) => row?.gateway },
  { header: 'Failure Reason', value: (row) => row?.payment_failure_reason },
  {
    header: 'Trigger',
    value: (row) => getPaymentFailedTrigger(row?.trigger_reason)?.label || row?.trigger_reason,
  },
  { header: 'Retry Count', value: (row) => row?.retry_count },
  { header: 'Outcome', value: (row) => getPaymentFailedOutcomeLabel(row?.outcome_type) },
  { header: 'Recovered Order No', value: (row) => row?.resolved_order_no },
  {
    header: 'Action Taken',
    value: (row) => getPaymentFailedStatusLabel(row?.action_status),
  },
  { header: 'Remarks', value: (row) => row?.remarks },
  { header: 'Updated By', value: (row) => row?.updated_by_username },
  { header: 'Latest Updated Date', value: (row) => formatDate(row?.updated_at) },
  { header: 'Closed Date', value: (row) => formatDate(row?.closed_at) },
];

const escapeCell = (value) => {
  if (value === null || value === undefined) return '';
  const text = String(value).replace(/"/g, '""');
  return `"${text}"`;
};

export const buildPaymentFailedOrdersCsv = (rows = []) => {
  const header = CSV_COLUMNS.map((column) => escapeCell(column.header)).join(',');
  const body = rows.map((row) =>
    CSV_COLUMNS.map((column) => escapeCell(column.value(row))).join(','),
  );
  return [header, ...body].join('\r\n');
};

export const downloadCsv = (fileName, csv) => {
  // BOM so Excel opens Arabic / accented names correctly
  const blob = new Blob([`﻿${csv}`], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
